export default __webpack_public_path__ + "static/days-03feeffc88a729cec65d6a9d2157773c.svg";